;(function() {
    var

    $mContainer = null,

    elems = {
        //hidden field containg the count of the groups
        $hdnGroupCount: null,

        //our main table body
        $tbody: null,

        //add group button
        $btnAddGroup: null,

        //min & max age hidden fields, for building new drop downs
        $minAge: null,
        $maxAge: null

    },

    //
    //init
    //
    init = function () {
        $mContainer = $(".layout-edit-group");

        if ($mContainer.length > 0) {
            //get the elements
            elems = {
                $hdnGroupCount: $("#group_count"),
                $tbody: $('table.table-group').find('tbody'),
                $btnAddGroup: $('#btnAddGroup'),
                $minAge: $('#age_min'),
                $maxAge: $('#age_max')
            };

            //call the various setup functions
            deleteGroupButtons();
            addGroup();
        }
    },



    //
    // delete clicks for recordings
    //
    deleteGroupButtons = function() {
        elems.$tbody.on('click', '.delete-group-button', function() {
            var $btn = $(this);

            //get the group index
            var index = $btn.attr('data-group-index');

            adc.popup.open({
                title: "Delete Group",
                body: "Are you sure you want to delete this group?",
                buttons: [
                    {
                        text: "Delete Group",
                        isPrimary: true,
                        callback: function() {
                            //update the hidden IsDeleted field
                            $("#groups_" + index + "__IsDeleted").val('True');

                            //hide the tr & error tr
                            $("#group_" + index).hide();
                            $("#group_err_" + index).hide();
                        }
                    },
                    {
                        text: "Cancel",
                    }
                ]
            });
        });
    },


    //
    // handles clicks on the Add Group button
    //
    addGroup = function() {
        elems.$btnAddGroup.click(function() {
            //get the group count & update it
            var index = parseInt(elems.$hdnGroupCount.val());
            elems.$hdnGroupCount.val(index + 1);

            //get the min & max age
            var minAge = parseInt(elems.$minAge.val());
            var maxAge = parseInt(elems.$maxAge.val());

            //build the html

            //open tr
            var s = "<tr id='group_" + index + "'>";

            //description
            s += "<td class='description'>";
            s += "<input id='groups_" + index + "__ID' name='groups[" + index + "].ID' type='hidden' value='0'>";
            s += "<input id='groups_" + index + "__IsDeleted' name='groups[" + index + "].IsDeleted' type='hidden' value='False'>";
            s += "<input class='form-control' id='groups_" + index + "__Name' name='groups[" + index + "].Name' type='text' value=''>";
            s += "</td>";

            //participants
            s += "<td class='participants'>";
            s += "<input class='form-control' id='groups_" + index + "__NumberParticipants' name='groups[" + index + "].NumberParticipants' type='text' value=''>";
            s += "</td>";

            //age from
            s += "<td class='age'>";
            s += "<select class='form-control' id='groups_" + index + "__AgeFrom' name='groups[" + index + "].AgeFrom'>";
            s += "<option value=''></option>";
            for(var i=minAge; i<=maxAge; i++) {
                s += "<option value='" + i + "'>" + i + "</option>";
            }
            s += "</select>";
            s += "</td>";

            //age to
            s += "<td class='age'>";
            s += "<select class='form-control' id='groups_" + index + "__AgeTo' name='groups[" + index + "].AgeTo'>";
            s += "<option value=''></option>";
            for(var i=minAge; i<=maxAge; i++) {
                s += "<option value='" + i + "'>" + i + "</option>";
            }
            s += "</select>";
            s += "</td>";

            //delete
            s += "<td class='delete'>";
            s += "<button type='button' class='delete-group-button btn btn-default btn-sm mt1' data-group-index='" + index + "'>";
            s += "<i class='fa fa-trash-o'></i> Delete";
            s += "</button>";
            s += "</td>";

            //close the tr
            s += "</tr>";

            //add it to the DOM
            elems.$tbody.append(s);
        });
    };


    //call init
    $(document).ready(init);

})();